module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/IceDay/Kanagawa_IceDay_MRI_RCP85_End.png";